import * as React from 'react';
import { FavoriteButton as FavoriteButtonComponent } from '../../components/FavoriteButton';
import { useDispatch, useSelector } from 'react-redux';
import { favoriteSelector } from '../../selectors/newbuilding';
import { addFavorite, removeFavorite } from '../../thunks';
import { TDispatch } from '../../types/redux';

export const FavoriteButton = () => {
  const dispatch: TDispatch = useDispatch();

  const isFavorite = useSelector(favoriteSelector);

  const onClick = React.useCallback(() => {
    if (isFavorite) {
      dispatch(removeFavorite());
    } else {
      dispatch(addFavorite());
    }
  }, [isFavorite, dispatch]);

  return <FavoriteButtonComponent isFavorite={isFavorite} onClick={onClick} />;
};
